import { Card } from 'antd';
import style from './style.module.scss';
import { Section } from '../../../../components/form-fields/section';

interface StatsSectionProps {
    totalGrants: number | null | undefined;
    totalActivations: number | null | undefined;
    discountValue: number | null | undefined;
    isPrivate: boolean | null | undefined;
}

const StatCard = ({
    label,
    value,
}: {
    label: string;
    value: number | string;
}) => (
    <Card className={style.stat_card}>
        <div className={`${style.stat_number} h3_medium`}>{value}</div>
        <div className={`${style.stat_label} footnote_description_bold`}>
            {label}
        </div>
    </Card>
);

export const StatsSection = ({
    totalGrants = 0,
    totalActivations = 0,
    discountValue = 0,
    isPrivate = false,
}: StatsSectionProps) => {
    const safeTotalActivations = totalActivations ?? 0;
    const safeDiscountValue = discountValue ?? 0;
    const totalCost = safeTotalActivations * safeDiscountValue;

    return (
        <Section title="Stats" noCard>
            <div className={style.stats_container}>
                {isPrivate && <StatCard label="won" value={totalGrants ?? 0} />}
                <StatCard
                    label="times activated"
                    value={safeTotalActivations}
                />
                <StatCard
                    label="cost"
                    value={`$${totalCost.toLocaleString()}`}
                />
            </div>
        </Section>
    );
};
